import { FieldValidationParams } from "../types";
import { validationException } from "./validator.utils";

const RULE_NAME = "maxStartingRepeatedChars";
const RULE_ERROR = "Invalid repeated characters encountered.";
export const maxStartingRepeatedCharsValidation = async ({
  args,
  names,
  onValidated,
  onInvalid,
  onValidationStarted,
}: FieldValidationParams<number>) => {
  return new Promise((resolve, reject) => {
    const [disallowedNumberOfRepetition, value, _defs, schema] = args;
    const { instancePath } = schema;
    const paths = (instancePath || "").split("/");
    const name = paths[paths.length - 1];

    if (onValidationStarted) {
      onValidationStarted(RULE_NAME, name);
    }
    if (
      value.length <= disallowedNumberOfRepetition ||
      disallowedNumberOfRepetition === 0
    ) {
      if (onValidated) {
        onValidated(names, name, RULE_NAME, []);
      }
      return resolve(true);
    }
    const firstChar = value[0];
    const substr = value.substring(0, disallowedNumberOfRepetition + 1);

    const result = substr.split("").filter(char => char === firstChar);
    const isValid = result.length <= disallowedNumberOfRepetition;

    if (isValid) {
      if (onValidated) {
        onValidated(names, name, RULE_NAME, []);
      }
      return resolve(true);
    }
    if (onInvalid) {
      onInvalid(names, name, RULE_NAME, 0, []);
    }
    return reject(validationException(RULE_NAME, RULE_ERROR));
  });
};
